import { ReactNode } from "react";
import { CommonContentMessage } from "../../types";
import { EventBody, MessageComponent, MessageComponentProps } from "./Message";
import { HighlightedText } from "../../agent/stateComponents/SimpleComponentVisualization";
import { isGeneratedContent } from "../../util/generatedContent";

const ContentMessage: MessageComponent<CommonContentMessage> = ({
  message,
  textFilter,
}: MessageComponentProps<CommonContentMessage>) => {
  let content: ReactNode = (
    <HighlightedText
      text={(message.content as string) ?? ""}
      textFilter={textFilter}
    />
  );

  if (isGeneratedContent(message)) {
    content = <span style={{ color: "var(--bs-code-color)" }}>{content}</span>;
  }
  return <EventBody>{content}</EventBody>;
};

export default ContentMessage;
